import {EventEmitter, Injectable} from '@angular/core';
import {HttpService} from '../../shared/services/http.service';
import {LogService} from '../../shared/services/log.service';
import {CTRL_NAME_EXTRACTOR} from '../validators/ctrl.name.extractor';
import {StepperBuilderService} from "../../avisDePub/creer/services/stepper.builder.service";
import {environment} from "../../../../environments/environment";
import { IdWebResponse } from '../common/models/idWebResponse';
import { SessionService } from '../../administration/services/session.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Endpoints } from '../../../models/endpoints';
import { TypeAnn } from '../common/models/type.ann';

@Injectable({
  providedIn: 'root'
})
export class IdWebApiService {

  private LOG: LogService = new LogService(IdWebApiService);

  public idWebResponse: EventEmitter<IdWebResponse> = new EventEmitter();

  constructor(private http: HttpService,
              private session: SessionService,
              private stepperBuilderService: StepperBuilderService) {
  }
 
  public validate(form: any, stepId) {
    if (environment.check_idWeb === 'false' || !this.stepperBuilderService.formulaire || this.stepperBuilderService.formulaire.toString().includes('E_FORM_') || this.stepperBuilderService.formulaire.toString().includes('_IN') || stepId !== 1) {
      this.idWebResponse.emit(null);
      this.idWebResponse.complete();
      return;
     }
    const dataIdWeb = {
      "idWeb" : this.getValueIdWebByFilter(form),
      "codeFormulaire" : this.stepperBuilderService.formulaire.toString(),
      "idUserStructure": this.session.getUser().siret,
      "idUserCodeService": this.session.getUser().service
    }
    this.checkDataIdWeb(form, dataIdWeb);
  }

  checkDataIdWeb(form: any, dataIdWeb: any) {
    const ctrlIdWeb = "CTRL_IDWEB";
    return this.http.post(Endpoints.IDWEB, dataIdWeb, IdWebResponse)
      .subscribe(
        (data) => {
          const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, ctrlIdWeb);
          if (rgs.length > 0) {
            for (let rg of rgs) {
              if (data.status == "KO") {
                form.controls[rg].value = [];
                if (data.erreurs && data.erreurs.length != 0) {
                  data.erreurs.forEach(error => {
                    this.stepperBuilderService.addStepFieldsOnErrors('_STEP_ID_1', '', error.toString());
                  });
                }
              }
              if (data.status == "OK") {
                form.controls[rg].value = {
                  rgCtrls: ctrlIdWeb,
                  ctrlValidation: false,
                };
              }
            }
          }
          this.idWebResponse.emit(data);
          this.idWebResponse.complete();
          return data;
        },
        (error) => {
          this.LOG.error('Appel back check id Web KO : ', error);
          return false;
        }
      );
  }

  getValueIdWebByFilter(form) {
    let idWeb;
		Object.keys(form.controls).forEach((key) => {
			if (key.includes('_SepAtt_idWeb') && form.controls[key]) {
				idWeb = form.controls[key].value;
			}
		});
    return idWeb;
	}


  /**
   * Méthode permettant d'appeler le service de verification de l'idWeb par rapport au loginAnnonceur
   * 
   * @param form Le formulaire où on récupère le loginAnnonceur
   * @param codeAvis Le code de l'avis
   * @param ann Annonceur contenant l'idWeb à récupérer
   * @returns Un observable de type boolean. True si Ok, false sinon.
   */
  verifyIdWeb(form: any, codeAvis: string, ann: TypeAnn): Observable<boolean> {

    const loginAnnonceur = form?.value?._SepSep_idAnnonceur_SepAtt_idannonceurboampweb;
    const idWeb = this.recuperationIdWebDansAvis(ann, codeAvis);

    const dataIdWeb = {
      "idWeb" : encodeURIComponent(idWeb),
      "loginAnnonceur" : encodeURIComponent(loginAnnonceur)
    }

    return this.http.post(Endpoints.IDWEB + Endpoints.VERIF_IDWEB, dataIdWeb);
  }

  /**
   * Méthode permettant de récupérer l'idWeb à partir d'un TypeAnn et du code de l'avis
   * 
   * @param ann Annonce contenant les infos de l'avis
   * @param codeAvis Code de l'avis
   * @returns L'idWeb
   */
  recuperationIdWebDansAvis(ann : TypeAnn, codeAvis: string) {
    let idWeb = '';
    if(ann != null) {
      switch (codeAvis) {
        case 'DIVE_AN':
          idWeb = ann.divers.annulation.avisInitial.idWeb;
          break;
        case 'DIVE_AT':
          idWeb = ann.divers.attribution.avisInitial.idWeb;
          break;
        case 'DIVE_RE':
          idWeb = ann.divers.rectificatif.avisInitial.idWeb;
          break;
        case 'MAPA_AN':
          idWeb = ann.mapa.annulationFromMAPA.avisInitial.idWeb;
          break;
        case 'MAPA_AT':
          idWeb = ann.mapa.attributionFromMAPA.avisInitial.idWeb;
          break;
        case 'MAPA_RE':
          idWeb = ann.mapa.rectificatifFromMAPA.avisInitial.idWeb;
          break;
        case 'SIMP_AN':
          idWeb = ann.fnSimple.annulationFromFNSimple.avisInitial.idWeb;
          break;
        case 'SIMP_AT':
          idWeb = ann.fnSimple.attribution.avisInitial.idWeb;
          break;
        case 'SIMP_RE':
          idWeb = ann.fnSimple.rectificatifFromFNSimple.avisInitial.idWeb;
          break;
      }
    }
    return idWeb;
  }

}
